// translation words
const t = (state) => {
  return state.translation;
};

// main language
const lng = (state) => {
  return state.language;
};

// file create function
const file = (state) => (id, type) => {
  var encode_URL = `${state.url.file_host}/files/pub/?id=${encodeURIComponent(
    id
  )}`;
  if (type) {
    return encodeURIComponent(encode_URL);
  }
  return encode_URL;
};

const thumb = (state) => (id) => {
  return `${state.url.file_host}/files/pub/thumb?id=${encodeURIComponent(id)}`;
};

const scrollSpeed = (state) => {
  return state.scrollSpeed;
};

// store state getter function
const musicPlaylist = (state) => {
  return state.musicPlayList;
};

const homepage = (state) => {
  return state.homepageList;
};

const sliderList = (state) => {
  return state.sliderList;
};

const announcements = (state) => {
  return state.announcements;
};

const announcements_menu = (state) => {
  let menu = [];
  if (state.announcements !== undefined) {
    state.announcements.find((item) => {
      menu.push(new Date(item.date).getFullYear());
    });
    menu = menu
      .filter((e, i, s) => {
        return i === s.indexOf(e);
      })
      .sort()
      .reverse();
  }
  return Array.isArray(state.announcements) ? menu : undefined;
};

const sezenden = (state) => {
  return state.sezenden_list.sort((a, b) => {
    return new Date(b.Date) - new Date(a.Date);
  });
};

const press_list = (state) => {
  return state.press_list;
};

const press_extra_images = (state) => {
  return state.press_extra_images;
};

const allwork_home = (state) => {
  return state.allwork_home;
};

const static_content = (state) => (type) => {
  const content = state.static_content.find((item) => {
    if (item.staticcontent_key == type && item.language == state.language) {
      return item.body;
    }
  });
  if (!content) {
    return "";
  }
  return content.body.replace(/src="/g, 'src="' + HOST);
};

const imageFixingUrl = (state) => (body) => {
  if (!body) {
    return body;
  }
  return body.replace(/src="/g, 'src="' + HOST);
};

const albums_list = (state) => {
  return state.albums_list;
};

const album_item = (state) => (id) => {
  return state.albums_list.find((item) => {
    return item.ID == id;
  });
};

const album_tracklist = (state) => {
  return state.album_tracklist;
};

const album_images = (state) => (link) => {
  let missLinkImages = [];
  state.album_images.find((img) => {
    if (img.link !== link) {
      missLinkImages.push(img);
    }
  });
  return missLinkImages;
};

const select_options = (state) => {
  return state.select_options;
};

const search_song_list = (state) => {
  return state.search_song_list;
};

const products_list = (state) => {
  return state.products_list;
};

const videos_list = (state) => {
  return state.videos_list;
};

const photos_list = (state) => {
  return state.photos_list;
};

const updates = (state) => {
  return state.updates;
};

export default {
  t,
  lng,
  file,
  thumb,
  scrollSpeed,
  musicPlaylist,
  homepage,
  static_content,
  sliderList,
  announcements,
  announcements_menu,
  sezenden,
  press_list,
  press_extra_images,
  allwork_home,
  albums_list,
  album_item,
  album_tracklist,
  album_images,
  select_options,
  search_song_list,
  products_list,
  videos_list,
  photos_list,
  updates,
  imageFixingUrl,
};
